const wnd: any = window

export const addGAEvent = (event: any) => {
  const cookieString = wnd.document.cookie
  const decodedCookie = cookieString ? decodeURIComponent(cookieString) : undefined
  const cookieValue = decodedCookie?.split(';').find(cookie => cookie.includes('OptanonConsent='))
  const groupsParam = cookieValue?.split('&').find(param => param.includes('groups='))
  const cookieValuePerformance = groupsParam?.split(',').find(val => val.startsWith('C0002:'))?.split('C0002:').pop()
  return cookieValuePerformance === '1' ? wnd.dataLayer?.push(event) : undefined
}
